<template>
  <el-drawer
    title="核验记录详情"
    append-to-body
    :close-on-press-escape="false"
    :visible.sync="show"
    size="720px"
    direction="rtl">
    <div
      v-if="ruleForm.id"
      class="detail-drawer-wrap">
      <el-descriptions
        direction="vertical"
        title="基础信息"
        :column="2">
        <el-descriptions-item label="用户姓名">{{ ruleForm.idName }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ ruleForm.mobilePhone }}</el-descriptions-item>
        <el-descriptions-item label="身份证号">{{ ruleForm.idNo }}</el-descriptions-item>
        <el-descriptions-item label="职业">{{ ruleForm.work }}</el-descriptions-item>
        <el-descriptions-item label="核验机构">{{ ruleForm.verificationCorpName }}</el-descriptions-item>
        <el-descriptions-item label="核验时间">{{ ruleForm.createdTime | dateformat() }}</el-descriptions-item>
        <el-descriptions-item label="涉网风险">
          <span :style="getStyle( ruleForm.publicSecIdVerificationResult)">{{ ruleForm.publicSecIdVerificationResult | getResult(ruleForm.publicSecIdVerificationResultInfo) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="涉诉情况">
          <span :style="getStyle( ruleForm.lawCaseVerificationResult)">{{ ruleForm.lawCaseVerificationResult | getResult(ruleForm.lawCaseVerificationResultInfo) }}</span>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions
        v-if="!!ruleForm.judicialCases"
        title="案件信息"
        direction="vertical"
        :column="1">
        <el-descriptions-item label="案件列表">
          <div
            v-for="item in ruleForm.judicialCases"
            :key="item.id"
            class="case-item">
            <case-detail :ruleForm="item" />
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>
<script>
import CaseDetail from './case-detail.vue'
const mapData = { 1: '核验中', 5: '身份证号不正确', 9: '正常' }
export default {
  name: 'HistoryDetailDrawer',
  components: { CaseDetail },
  filters: {
    getResult(val, val1) {
      return mapData[val] || val1
    }
  },
  data() {
    return { show: false, loading: false, ruleForm: {}}
  },
  methods: {
    getStyle(val) {
      const map = { 1: '', 5: '', 9: '#67c23a', 13: '#f56c6c', 17: '' }
      return { color: map[val] }
    },
    init(row = {}) {
      this.ruleForm = { ...this.ruleForm, ...row }
      this.show = true
    }
  }
}
</script>
<style lang="stylus" scoped>
.detail-drawer-wrap {
  /deep/.el-descriptions-item__label {
    font-weight: bold !important;
  }

  .case-item+.case-item {
    margin-top: 10px;
  }
}
</style>
